/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTemporalClosureRequestProductsInner
 */
export interface CreateTemporalClosureRequestProductsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateTemporalClosureRequestProductsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTemporalClosureRequestProductsInner
     */
    product: CreateTemporalClosureRequestProductsInnerProductEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTemporalClosureRequestProductsInner
     */
    brandId?: string;
}


/**
 * @export
 */
export const CreateTemporalClosureRequestProductsInnerProductEnum = {
    Bookings: 'BOOKINGS',
    Shop: 'SHOP',
    Uber: 'UBER',
    Glovo: 'GLOVO',
    Flyt: 'FLYT',
    Rappi: 'RAPPI',
    Didi: 'DIDI'
} as const;
export type CreateTemporalClosureRequestProductsInnerProductEnum = typeof CreateTemporalClosureRequestProductsInnerProductEnum[keyof typeof CreateTemporalClosureRequestProductsInnerProductEnum];


/**
 * Check if a given object implements the CreateTemporalClosureRequestProductsInner interface.
 */
export function instanceOfCreateTemporalClosureRequestProductsInner(value: object): value is CreateTemporalClosureRequestProductsInner {
    if (!('product' in value) || value['product'] === undefined) return false;
    return true;
}

export function CreateTemporalClosureRequestProductsInnerFromJSON(json: any): CreateTemporalClosureRequestProductsInner {
    return CreateTemporalClosureRequestProductsInnerFromJSONTyped(json, false);
}

export function CreateTemporalClosureRequestProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTemporalClosureRequestProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'product': json['product'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
    };
}

export function CreateTemporalClosureRequestProductsInnerToJSON(json: any): CreateTemporalClosureRequestProductsInner {
    return CreateTemporalClosureRequestProductsInnerToJSONTyped(json, false);
}

export function CreateTemporalClosureRequestProductsInnerToJSONTyped(value?: CreateTemporalClosureRequestProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'product': value['product'],
        'brandId': value['brandId'],
    };
}

